import Header from './header';
import SignInHeader from './sign-in-header';
import SignInFooter from './sign-in-footer';
import AuthFooter from './footer';
import './css/index.css';

const authComponents = {
  components: {
    Header,
    SignIn: {
      Header: SignInHeader,
      Footer: SignInFooter,
    },
    AuthFooter,
  },
};
export default authComponents;
